import { CustomWarning } from '@componentsNew/CustomWarning';
import { alert } from '@componentsNew/CustomWarning/types';
import Typography from '@componentsNew/Typography';
import CarregamentoAnalise from '@pages/DicasOtimizacao/AnalisesTextuais/Components/CarregamentoAnalise';

export const CardSeoItem = ({ carregando, children, erro = null }) => {
  return (
    <div className="w-full">
      {carregando && erro === null && (
        <div className="min-h-[15.438em] items-center justify-center flex">
          <CarregamentoAnalise />
        </div>
      )}

      {!carregando && erro === null && children}

      {erro && (
        <CustomWarning
          alertType={alert.warning}
          content={
            <div>
              <Typography className="font-[0.75rem]">
                Houve um erro inesperado ao tentar gerar as analises.
              </Typography>
            </div>
          }
        />
      )}
    </div>
  );
};
